import { render, staticRenderFns } from "./PrivacyClaim.vue?vue&type=template&id=24a10f0b"
import script from "./PrivacyClaim.vue?vue&type=script&lang=js"
export * from "./PrivacyClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports